import React, { useEffect, useState } from "react";
import BackIcon from "../../Assets/Icons/BackIcon";
import "./mou.css";
import NavbarCustom from "../../Components/NavbarCustom";
import { InputText } from "primereact/inputtext";
import { useMOU } from "../../APIContext/MOUContext";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

const MOUForm = () => {
  const { addMOUdata, getMOUFormData } = useMOU();
  const [selectAll, setSelectAll] = useState(false);
  const [popFormData, setPopFormData] = useState({});
  const [selectedPackages, setSelectedPackages] = useState([]);
  const [formData, setFormData] = useState({
    parent_id: "",
    player_id: "",
    player_full_name: "",
    player_address: "",
    date_of_birth: "",
    renewal_month: "",
    agency_fi: "",
    broker: "",
    broker_phone: "",
    broker_email: "",
    parent_name: "",
    parent_phone: "",
    parent_email: "",
    parent_signature: null,
  });

  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const playerID = Number(queryParams.get("player_id"));
  const userData = JSON.parse(localStorage.getItem("user"));

  // Fetch MOU data
  useEffect(() => {
    const fetchMOUFormData = async () => {
      try {
        const data = await getMOUFormData(playerID);
        setPopFormData(data);
        // console.log("MOU Form Data:", data);
      } catch (err) {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: `Failed to fetch MOU form data: ${err.message}`,
          confirmButtonColor: "#B79527", // orange / gold
          cancelButtonColor: "#1C1C1C",
        });
      }
    };
    fetchMOUFormData();
  }, [playerID]);

  // Populate form after fetch
  useEffect(() => {
    if (popFormData?.player && popFormData?.parent) {
      setFormData({
        parent_id: popFormData.parent.id || "",
        player_id: popFormData.player.id || "",
        player_full_name: popFormData.player.name || "",
        player_address: "",
        date_of_birth: popFormData.player.date_of_birth || "",
        renewal_month: "",
        agency_fi: "",
        broker: "",
        broker_phone: "",
        broker_email: "",
        parent_name: popFormData.parent.name || "",
        parent_phone: popFormData.parent.phone || "",
        parent_email: popFormData.parent.email || "",
        parent_signature: null,
      });
    }
  }, [popFormData]);

  // Handle text input changes
  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id.replace("-", "_")]: value }));
  };

  // Handle file upload
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    // Check if file is PDF
    if (file.type === "application/pdf") {
      Swal.fire({
        icon: "warning",
        title: "Invalid File!",
        text: "PDF files are not allowed. Please upload an image file (PNG or JPG).",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
      e.target.value = ""; // reset input
      return;
    }

    // Otherwise accept the file
    setFormData((prev) => ({ ...prev, parent_signature: file }));
  };

  // Handle package selection
  // const handlePackageSelect = (pkgId) => {
  //     setSelectedPackages((prev) =>
  //         prev.includes(pkgId) ? prev.filter((id) => id !== pkgId) : [...prev, pkgId]
  //     );
  // };
  const handlePackageSelect = (pkgId) => {
    setSelectedPackages((prev) => {
      let updated = prev.includes(pkgId)
        ? prev.filter((id) => id !== pkgId)
        : [...prev, pkgId];

      // Sync Select All checkbox
      if (popFormData.available_packages) {
        setSelectAll(updated.length === popFormData.available_packages.length);
      }
      return updated;
    });
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    // Check if all packages selected
    // if (selectedPackages.length !== popFormData.available_packages?.length) {
    //     return Swal.fire({
    //         icon: "warning",
    //         title: "Required!",
    //         text: "Please select all packages before proceeding.",
    //     });
    // }

    const requiredFields = {
      player_full_name: "Player Full Name",
      player_address: "Player Address",
      date_of_birth: "Date of Birth",
      renewal_month: "Renewal Month",
      agency_fi: "Agency / FI",
      broker: "Broker Name",
      broker_phone: "Broker Phone Number",
      broker_email: "Broker Email",
      parent_name: "Parent Name",
      parent_phone: "Parent Phone Number",
      parent_email: "Parent Email",
    };

    // ✅ Check empty fields
    for (let field in requiredFields) {
      if (!formData[field] || formData[field].toString().trim() === "") {
        return Swal.fire({
          icon: "warning",
          title: "Required Field Missing!",
          text: `${requiredFields[field]} is required.`,
          confirmButtonColor: "#B79527", // orange / gold
          cancelButtonColor: "#1C1C1C",
        });
      }
    }

    // ✅ Validate Email
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(formData.broker_email)) {
      return Swal.fire({
        icon: "warning",
        title: "Invalid Email",
        text: "Enter a valid Broker Email address.",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
    }

    if (!emailRegex.test(formData.parent_email)) {
      return Swal.fire({
        icon: "warning",
        title: "Invalid Email",
        text: "Enter a valid Parent Email address.",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
    }

    if (!formData.broker_phone) {
      return Swal.fire({
        icon: "warning",
        title: "Invalid Phone",
        text: "Enter a valid Broker phone number.",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
    }

    if (!formData.parent_phone) {
      return Swal.fire({
        icon: "warning",
        title: "Invalid Phone",
        text: "Enter a valid Parent phone number.",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
    }

    // ✅ Parent Signature Required
    if (!formData.parent_signature) {
      return Swal.fire({
        icon: "warning",
        title: "Signature Required!",
        text: "Please upload Parent Signature.",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
    }

    // ✅ Package selection required
    if (!selectedPackages.length) {
      return Swal.fire({
        icon: "warning",
        title: "Package Required!",
        text: "Please select at least one package.",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
    }

    // ✅ Must select ALL packages
    if (selectedPackages.length !== popFormData.available_packages?.length) {
      return Swal.fire({
        icon: "warning",
        title: "All Packages Required!",
        text: "Please select all packages before proceeding.",
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
    }
    try {
      const payload = new FormData();

      // Append all key-value pairs to form-data
      for (const [key, value] of Object.entries(formData)) {
        if (value !== null) payload.append(key, value);
      }

      // Append package IDs as multiple entries
      selectedPackages.forEach((pkgId) => {
        payload.append("package_ids", pkgId);
      });

      for (const pair of payload.entries()) {
        // console.log(pair[0] + ':', pair[1]);
      }

      // Call context API
      const response = await addMOUdata(payload);

      if (response) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "MOU form submitted successfully!",
          confirmButtonColor: "#B79527", // orange / gold
          cancelButtonColor: "#1C1C1C",
        });

        if (userData?.has_preferences === true) {
          navigate("/");
        } else {
          navigate("/preferences");
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Submission Failed",
        text: err.message,
        confirmButtonColor: "#B79527", // orange / gold
        cancelButtonColor: "#1C1C1C",
      });
    }
  };

  return (
    <>
      <NavbarCustom />
      <div className="container mou-container">
        <div className="header">
          <div className="backIcon">
            <BackIcon />
          </div>
          <h1 className="heading black-text-clip">BWC New Client / MOU Form</h1>
        </div>

        <div className="form-container">
          <form onSubmit={handleSubmit}>
            {/* PACKAGE SELECTION */}
            {/* <div className="form-package">
                            <h2>Package</h2>
                            {popFormData.available_packages && popFormData.available_packages.length > 0 ? (
                                popFormData.available_packages.map((pkg, index) => (
                                    <div className="form-package-input" key={pkg.id}>
                                        <input
                                            type="checkbox"
                                            id={`pkg${pkg.id}`}
                                            value={pkg.id}
                                            checked={selectedPackages.includes(pkg.id)}
                                            onChange={() => handlePackageSelect(pkg.id)}
                                        />
                                        <label htmlFor={`pkg${pkg.id}`}>{pkg.name}</label>
                                    </div>
                                ))
                            ) : (
                                <p>No packages available.</p>
                            )}
                        </div> */}

            <div className="form-package">
              <div className="package-header">
                <h2
                  className="black-text-clip"
                  style={{ marginBottom: "1rem" }}
                >
                  Package
                </h2>

                {/* SELECT ALL CHECKBOX */}
                <label className="select-all-label black-text-clip">
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={() => {
                      const newState = !selectAll;
                      setSelectAll(newState);

                      // If true → select all IDs, else → empty
                      if (newState && popFormData.available_packages) {
                        setSelectedPackages(
                          popFormData.available_packages.map((pkg) => pkg.id),
                        );
                      } else {
                        setSelectedPackages([]);
                      }
                    }}
                  />
                  Select All
                </label>
              </div>

              <div className="package-grid-mou">
                {popFormData.available_packages &&
                popFormData.available_packages.length > 0 ? (
                  popFormData.available_packages.map((pkg) => (
                    <div className="form-package-input" key={pkg.id}>
                      <input
                        type="checkbox"
                        id={`pkg${pkg.id}`}
                        value={pkg.id}
                        checked={selectedPackages.includes(pkg.id)}
                        onChange={() => handlePackageSelect(pkg.id)}
                      />
                      <label
                        className="black-text-clip"
                        htmlFor={`pkg${pkg.id}`}
                      >
                        {pkg.name} {pkg.price ? `- Price: $${pkg.price}` : ""}{" "}
                        {pkg.sport_type ? `- ${pkg.sport_type}` : ""}
                      </label>
                    </div>
                  ))
                ) : (
                  <p className="black-text-clip">No packages available.</p>
                )}
              </div>
            </div>

            {/* PLAYER DETAILS */}
            <div className="form-player-details">
              <div className="form-player-item">
                <label className="black-text-clip" htmlFor="player-full_name">
                  Player Full Name
                </label>
                <InputText
                  id="player-full_name"
                  value={formData.player_full_name}
                  onChange={handleChange}
                />
              </div>
              <div className="form-player-item">
                <label className="black-text-clip" htmlFor="player-address">
                  Player Address
                </label>
                <InputText
                  id="player-address"
                  value={formData.player_address}
                  onChange={handleChange}
                />
              </div>
              <div className="form-player-item">
                <label className="black-text-clip" htmlFor="date-of_birth">
                  Date of Birth of Player
                </label>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    value={
                      formData.date_of_birth
                        ? dayjs(formData.date_of_birth, "YYYY-MM-DD")
                        : null
                    } // parse API date
                    onChange={(newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        date_of_birth: newValue
                          ? dayjs(newValue).format("YYYY-MM-DD")
                          : "", // send in ISO format
                      }));
                    }}
                    format="MM/DD/YYYY" // display in MM/DD/YYYY
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        className: "form-player-calender",
                      },
                    }}
                  />
                </LocalizationProvider>
              </div>
            </div>

            {/* RENEWAL MONTH */}
            <div className="renewal-month">
              <h2 className="black-text-clip">Renewal Month</h2>
              <div className="month-container">
                {[
                  "January",
                  "February",
                  "March",
                  "April",
                  "May",
                  "June",
                  "July",
                  "August",
                  "September",
                  "October",
                  "November",
                  "December",
                ].map((m) => (
                  <label key={m} className="month-label black-text-clip">
                    <input
                      type="radio"
                      name="renewal_month"
                      value={m}
                      checked={formData.renewal_month === m}
                      onChange={() =>
                        setFormData((prev) => ({ ...prev, renewal_month: m }))
                      }
                    />{" "}
                    {m}
                  </label>
                ))}
              </div>
            </div>

            {/* AGENCY + PARENT DETAILS */}
            <div className="form-agency-details">
              <div className="row-agency">
                <div className="agency-details">
                  <label className="black-text-clip" htmlFor="agency-fi">
                    Agency/FI
                  </label>
                  <InputText
                    id="agency-fi"
                    value={formData.agency_fi}
                    onChange={handleChange}
                  />
                </div>
                <div className="agency-details">
                  <label className="black-text-clip" htmlFor="broker">
                    Broker
                  </label>
                  <InputText
                    id="broker"
                    value={formData.broker}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="row-agency">
                <div className="agency-details">
                  <label className="black-text-clip" htmlFor="broker-phone">
                    Broker Phone Number
                  </label>
                  <InputText
                    id="broker-phone"
                    value={formData.broker_phone}
                    onChange={handleChange}
                  />
                </div>
                <div className="agency-details">
                  <label className="black-text-clip" htmlFor="broker-email">
                    Broker Email
                  </label>
                  <InputText
                    id="broker-email"
                    value={formData.broker_email}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="row-agency">
                <div className="agency-details">
                  <label className="black-text-clip" htmlFor="parent-name">
                    Parent Name
                  </label>
                  <InputText
                    id="parent-name"
                    value={formData.parent_name}
                    onChange={handleChange}
                  />
                </div>
                <div className="agency-details">
                  <label className="black-text-clip" htmlFor="parent-phone">
                    Parent Phone Number
                  </label>
                  <InputText
                    id="parent-phone"
                    value={formData.parent_phone}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="row-agency">
                <div className="agency-details">
                  <label className="black-text-clip" htmlFor="parent-email">
                    Parent Email
                  </label>
                  <InputText
                    id="parent-email"
                    value={formData.parent_email}
                    onChange={handleChange}
                  />
                </div>
                <div className="agency-details">
                  <label className="black-text-clip" htmlFor="parent-signature">
                    Parent Signature
                  </label>
                  <input
                    type="file"
                    id="parent-signature"
                    onChange={handleFileChange}
                  />
                </div>
              </div>
            </div>

            <button id="submit-button" type="submit">
              Proceed
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default MOUForm;
